var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTowtruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7158 2.57492C22.4255 2.02262 21.8628 1.67822 21.251 1.67822H17.2903C16.371 1.67822 15.6257 2.44304 15.6257 3.38552V10.4953H2.44517C1.63968 10.4953 0.986938 11.1652 0.986938 11.9913V16.8335C0.986938 17.6596 1.63968 18.3295 2.44517 18.3295H25.4259C26.2313 18.3295 26.8845 17.6596 26.8845 16.8335V10.5528C26.8845 10.515 26.8751 10.4781 26.8575 10.4449L22.7158 2.57492Z",
    fill: "#A483B0",
    stroke: "#63768D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0472 9.50179H18.2721C17.4887 9.50179 16.8531 8.85037 16.8531 8.04649V3.84019C16.8531 3.42313 17.1832 3.08545 17.5894 3.08545H21.2311C21.5014 3.08545 21.7504 3.23749 21.8789 3.48151L25.0472 9.50179Z",
    fill: "#E1E0E9",
    stroke: "#63768D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30005 6.09584C2.42167 6.70484 2.94706 7.16264 3.57646 7.16264C4.29595 7.16264 4.87949 6.56456 4.87949 5.82662C4.87949 5.08868 4.29595 4.4906 3.57646 4.4906L4.92453 1.49726C5.31561 0.897083 6.14976 0.828203 6.62928 1.35614L14.8885 10.0657",
    stroke: "#63768D",
    strokeWidth: 1.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6904 12.3477L24.1503 12.3951C24.0413 12.3972 23.9971 12.54 24.0847 12.6064L25.7932 13.9038C26.0753 14.1079 26.477 14.0533 26.6904 13.7815V12.3477Z",
    stroke: "#63768D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6207 10.4954H15.6256V8.65332H13.615C13.0659 8.65332 12.6207 9.10986 12.6207 9.67308V10.4954Z",
    fill: "#63768D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0212 18.2604C19.0502 19.7968 20.2358 21.019 21.6682 20.9904C23.101 20.9623 24.2386 19.6931 24.2095 18.1567C24.1805 16.6203 22.9954 15.3977 21.5625 15.4263C20.1297 15.4548 18.9921 16.7237 19.0212 18.2604Z",
    fill: "#E1E0E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0212 18.2604C19.0502 19.7968 20.2358 21.019 21.6682 20.9904C23.101 20.9623 24.2386 19.6931 24.2095 18.1567C24.1805 16.6203 22.9954 15.3977 21.5625 15.4263C20.1297 15.4548 18.9921 16.7237 19.0212 18.2604",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39532 18.2604C3.4244 19.7968 4.6099 21.019 6.04233 20.9904C7.47517 20.9623 8.61276 19.6931 8.58369 18.1567C8.55461 16.6203 7.36952 15.3977 5.93668 15.4263C4.50384 15.4548 3.36625 16.7237 3.39532 18.2604Z",
    fill: "#E1E0E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39532 18.2604C3.4244 19.7968 4.6099 21.019 6.04233 20.9904C7.47517 20.9623 8.61276 19.6931 8.58369 18.1567C8.55461 16.6203 7.36952 15.3977 5.93668 15.4263C4.50384 15.4548 3.36625 16.7237 3.39532 18.2604",
    stroke: "#63768D",
    strokeWidth: 0.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.139 11.4068C16.9821 11.4068 16.8531 11.2749 16.8531 11.114C16.8531 10.9527 16.9821 10.8204 17.139 10.8204H18.8871C19.0444 10.8204 19.1726 10.9527 19.1726 11.114C19.1726 11.2749 19.0444 11.4068 18.8871 11.4068H17.139Z",
    fill: "#63768D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3 18.3294H15.95V10.4956H15.3V18.3294Z",
    fill: "#63768D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowtruck);
export default __webpack_public_path__ + "static/media/towtruck.ea146f73.svg";
export { ForwardRef as ReactComponent };